/**
 * User: Rob Richard
 * Date: 9/22/14
 * Time: 8:10 PM
 */

'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var CurrencyConversionRateEvent = module.exports = SoaModel.extend();

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var CurrencyConversionRate = require('bunsen/models/ecomm/CurrencyConversionRate');
var ends = require('dibs-endpoints');

// for browser console debugging
if (typeof window !== 'undefined') {
    window.bunsen = window.bunsen || {};
    window.bunsen.CurrencyConversionRateEvent = CurrencyConversionRateEvent;
}

_.extend(CurrencyConversionRateEvent.prototype, {
    relations: [
        {
            key: 'conversionRates',
            type: Backbone.Many,
            // needed until MONEY-374 is resolved
            // omitFromSave: true,
            relatedModel: CurrencyConversionRate
        }
    ],
    fetchCurrentRates: function (options) {
        options = _.extend({
            url: ends.currentRates()
        }, options);

        return this.fetch(options);
    }
});




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/CurrencyConversionRateEvent.js
// module id = 326
// module chunks = 62